import styled from "styled-components/macro";

const SummaryColumn = styled.div.attrs({
    className: "col-lg-12 col-md-12 col-xs-12"
})`
    font-family:  ${props => props.theme.longTextFamily};
`;

const SubHeaderText = styled.h2`
    font-family:  ${props => props.theme.highlightFontFamily};
    font-size: 2rem;
    line-height: normal;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    font-weight: inherit;
`;

const ItalicText = styled.span`
    font-style: oblique;
`;

const Paragraph = styled.p``;

export {SummaryColumn, SubHeaderText, ItalicText, Paragraph}
